<template>
  <div
      class="d-flex ai-center jc-between bg-white"
      :class="[ focused ? 'FOCUSED-BORDER' : 'bd-gray50' ]">
    <input
        ref="whatsNewSearchInput"
        v-model="searchText"
        aria-label="Job Search Input"
        type="text"
        class="SEARCH-INPUT input bd-transparent c-gray70"
        :placeholder="placeholderText"
        visible-placeholder
        @focus="onFocus(true)"
        @blur="onFocus(false)"
        @keydown.esc.prevent="onClear()"
        @keydown.enter.prevent="onSubmit()">
    <button
        aria-label="Search Button"
        class="SEARCH-BTN d-flex jc-center ai-center"
        @click.prevent="onSubmit()">
      <vk-icon name="magnifyglass" size="15" class="c-depot flex-0-0" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'education-search-input',
  props: {
    results: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: String,
      required: true,
    },
    placeholderText: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      searchText: '',
      focused: false,
      isClear: true,
    };
  },
  methods: {
    input () {
      this.$emit('input', this.searchText);
    },
    onSubmit () {
      this.$emit('input', this.searchText);
      this.searchText = '';
    },
    onFocus (isFocus) {
      this.focused = isFocus;
    },
    onClear () {
      this.searchText = '';
      this.onSubmit();
      this.$refs.whatsNewSearchInput.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

$size: 44px;

.SEARCH-INPUT {
  height: $size;
  width: $unit * 37.5;
  font-size: 14px;
  @include mobile-only {
    width: $unit * 30;
  }
}
::placeholder {
  color: $color-gray60;
}
.FOCUSED-BORDER {
  border: 1px solid $color-depot;
}
.SEARCH-BTN {
  width: $size;
  height: $size;

  background-color: white;
  border: 0px solid white;
  border-left: 1px $color-gray60 solid;

}
.ICON {
  height: inherit;
}
.INPUT-APPEND {
  & > label {
    cursor: pointer;
    user-select: none;
  }
}
</style>
